import { Component, Input } from '@angular/core'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'
import { Currency } from '@app/shared/models/currency.model'

@Component({
  selector: 'lin-billing-table',
  templateUrl: './billing-table.component.html',
  styleUrls: ['./billing-table.component.scss'],
  standalone: false,
})
export class BillingTableComponent {
  @Input() caption: string
  @Input() tableHeader = false
  @Input() notes = false
  @Input() scrollable = false

  get clientCurrency(): Currency {
    return this.platformSettingsService.getClientCurrency()
  }

  constructor(private readonly platformSettingsService: PlatformSettingsService) {}
}
